export class TranslationHelper {
  private translationPrefix?: string;
  private strictPrefix?: string;

  setTranslationPrefix(prefix: string) {
    this.translationPrefix = prefix;
  }

  setStrictPrefix(prefix: string) {
    this.strictPrefix = prefix;
  }

  getTranslationKey(name: string) {
    return this.translationPrefix + '.' + name;
  }

  getStrictKey(name: string) {
    return this.strictPrefix + '.' + name;
  }
}
